import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Text, Heading } from "@chakra-ui/react"
import { FeaturedImage } from "../../"

export function Welcome() {
  const { dataJson } = useStaticQuery(graphql`
    {
      dataJson {
        about {
          imagePosition
          intro
          title
          copy
          image {
            childImageSharp {
              gatsbyImageData(
                placeholder: BLURRED
                layout: FIXED
                width: 1400
                height: 933
              )
            }
          }
        }
      }
    }
  `)

  const { title, intro, copy, image, imagePosition } = dataJson.about

  return (
    <section>
      <FeaturedImage image={image} imagePosition={imagePosition}>
        <Heading fontWeight="semibold" letterSpacing="wide" size="3xl" as="h2">
          {title}
        </Heading>
        <Heading as="h4" size="lg" lineHeight="1.4" color="text.300">
          {intro}
        </Heading>
        <Text mt={4} color="text.300">
          {copy}
        </Text>
      </FeaturedImage>
    </section>
  )
}
